export default __webpack_public_path__ + "static/media/brand-image-07.045d8787.jpg";